import { useLayoutEffect, useRef } from 'react';

const Slideshow = (props) => {
    let slideIndex = 0;
    const timeoutRef = useRef(null);

    useLayoutEffect(() => {
        slideIndex = 0;
        timeoutRef.current = setTimeout(showSlides, 500);
        return () => {
            slideIndex = 0;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    });

    function getDots() {
        let arr = [];
        for (let i = 0; i < props.children.length; i++) {
            arr.push(<div className={i === 0 ? "dot active" : "dot"} key={i} onClick={() => { showSlides(i); }}></div>);
        }
        return arr;
    }

    function showSlides(imgNum = null) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        let i;
        if (imgNum !== null) {
            slideIndex = imgNum
        }
        let slides = document.getElementsByClassName("mySlide");
        let dots = document.getElementsByClassName("dot");
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        slideIndex++;
        if (slideIndex > slides.length) {
            slideIndex = 1
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex - 1].style.display = "block";
        dots[slideIndex - 1].className += " active";
        timeoutRef.current = setTimeout(showSlides, props.speed || 3000);
    }

    return (
        <div className="slideshow-container">
            <div className='slide-container'>
                {props.children.map((x, i) => {
                    return (
                        <div className={props.speed ? 'mySlide' : 'mySlide fade'} key={i} style={{ display: i === 0 ? 'active' : 'none' }}>
                            {x}
                        </div>
                    );
                })}
            </div>
            <div className='dot-container'>
                {getDots().map(x => x)}
            </div>
        </div>
    );
};

export default Slideshow;
